import { createRoot } from 'react-dom/client';

import { App, AppProps } from './App';

function mount(DOMElement: Element, options: AppProps) {
  const root = createRoot(DOMElement);
  
  root.render(<App {...options} />);
}

const isolatedContainer = document.getElementById(
  '__isolated_whatsapp_coexistence_module'
);

if (isolatedContainer) {
  mount(isolatedContainer, {
    initialPath: '',
    routerStrategy: 'browser',
    refresh: () => {
      // eslint-disable-next-line no-console
      window.location.reload();
    },
  });
}

export default mount;
